import React, { memo } from 'react'
import { SettingsModal } from './SettingsModal'
import { Navigate, Route, Routes } from 'react-router-dom'
import { EmailNotificationsSection } from './EmailNotificationsSection'
import { DeclineReasonsSection } from './DeclineReasonsSection'

const SettingsComponent = () => {
  return (
    <Routes>
      <Route path="settings" element={<SettingsModal />}>
        <Route index element={<Navigate to="notifications" replace />} />
        <Route path="notifications" element={<EmailNotificationsSection />} />
        <Route path="decline-reasons" element={<DeclineReasonsSection />} />
      </Route>
    </Routes>
  )
}

export const Settings = memo(SettingsComponent)
